/**
 * All 206 Sonic Pi / SuperSonic sample files (supersonic-scsynth-samples@0.67.2).
 * Auto-generated — run build-samples-manifest.js to refresh.
 */

const SAMPLE_CATEGORIES = [
    {
        "id": "drums",
        "label": "Drums",
        "items": [
            {
                "text": "bass hard",
                "value": "drum_bass_hard.flac"
            },
            {
                "text": "bass soft",
                "value": "drum_bass_soft.flac"
            },
            {
                "text": "cowbell",
                "value": "drum_cowbell.flac"
            },
            {
                "text": "cymbal closed",
                "value": "drum_cymbal_closed.flac"
            },
            {
                "text": "cymbal hard",
                "value": "drum_cymbal_hard.flac"
            },
            {
                "text": "cymbal open",
                "value": "drum_cymbal_open.flac"
            },
            {
                "text": "cymbal pedal",
                "value": "drum_cymbal_pedal.flac"
            },
            {
                "text": "cymbal soft",
                "value": "drum_cymbal_soft.flac"
            },
            {
                "text": "heavy kick",
                "value": "drum_heavy_kick.flac"
            },
            {
                "text": "roll",
                "value": "drum_roll.flac"
            },
            {
                "text": "snare hard",
                "value": "drum_snare_hard.flac"
            },
            {
                "text": "snare soft",
                "value": "drum_snare_soft.flac"
            },
            {
                "text": "splash hard",
                "value": "drum_splash_hard.flac"
            },
            {
                "text": "splash soft",
                "value": "drum_splash_soft.flac"
            },
            {
                "text": "tom hi hard",
                "value": "drum_tom_hi_hard.flac"
            },
            {
                "text": "tom hi soft",
                "value": "drum_tom_hi_soft.flac"
            },
            {
                "text": "tom lo hard",
                "value": "drum_tom_lo_hard.flac"
            },
            {
                "text": "tom lo soft",
                "value": "drum_tom_lo_soft.flac"
            },
            {
                "text": "tom mid hard",
                "value": "drum_tom_mid_hard.flac"
            },
            {
                "text": "tom mid soft",
                "value": "drum_tom_mid_soft.flac"
            }
        ]
    },
    {
        "id": "hats",
        "label": "Hats & bass drum",
        "items": [
            {
                "text": "808",
                "value": "bd_808.flac"
            },
            {
                "text": "ada",
                "value": "bd_ada.flac"
            },
            {
                "text": "boom",
                "value": "bd_boom.flac"
            },
            {
                "text": "chip",
                "value": "bd_chip.flac"
            },
            {
                "text": "fat",
                "value": "bd_fat.flac"
            },
            {
                "text": "gas",
                "value": "bd_gas.flac"
            },
            {
                "text": "haus",
                "value": "bd_haus.flac"
            },
            {
                "text": "jazz",
                "value": "bd_jazz.flac"
            },
            {
                "text": "klub",
                "value": "bd_klub.flac"
            },
            {
                "text": "mehackit",
                "value": "bd_mehackit.flac"
            },
            {
                "text": "pure",
                "value": "bd_pure.flac"
            },
            {
                "text": "sone",
                "value": "bd_sone.flac"
            },
            {
                "text": "tek",
                "value": "bd_tek.flac"
            },
            {
                "text": "zome",
                "value": "bd_zome.flac"
            },
            {
                "text": "zum",
                "value": "bd_zum.flac"
            },
            {
                "text": "bdu",
                "value": "hat_bdu.flac"
            },
            {
                "text": "cab",
                "value": "hat_cab.flac"
            },
            {
                "text": "cats",
                "value": "hat_cats.flac"
            },
            {
                "text": "gem",
                "value": "hat_gem.flac"
            },
            {
                "text": "gnu",
                "value": "hat_gnu.flac"
            },
            {
                "text": "gump",
                "value": "hat_gump.flac"
            },
            {
                "text": "hier",
                "value": "hat_hier.flac"
            },
            {
                "text": "len",
                "value": "hat_len.flac"
            },
            {
                "text": "mess",
                "value": "hat_mess.flac"
            },
            {
                "text": "metal",
                "value": "hat_metal.flac"
            },
            {
                "text": "noiz",
                "value": "hat_noiz.flac"
            },
            {
                "text": "psych",
                "value": "hat_psych.flac"
            },
            {
                "text": "raw",
                "value": "hat_raw.flac"
            },
            {
                "text": "sci",
                "value": "hat_sci.flac"
            },
            {
                "text": "snap",
                "value": "hat_snap.flac"
            },
            {
                "text": "star",
                "value": "hat_star.flac"
            },
            {
                "text": "tap",
                "value": "hat_tap.flac"
            },
            {
                "text": "yosh",
                "value": "hat_yosh.flac"
            },
            {
                "text": "zan",
                "value": "hat_zan.flac"
            },
            {
                "text": "zap",
                "value": "hat_zap.flac"
            },
            {
                "text": "zild",
                "value": "hat_zild.flac"
            }
        ]
    },
    {
        "id": "snares",
        "label": "Snares",
        "items": [
            {
                "text": "dolf",
                "value": "sn_dolf.flac"
            },
            {
                "text": "dub",
                "value": "sn_dub.flac"
            },
            {
                "text": "generic",
                "value": "sn_generic.flac"
            },
            {
                "text": "zome",
                "value": "sn_zome.flac"
            }
        ]
    },
    {
        "id": "cymbals",
        "label": "Ride cymbals",
        "items": [
            {
                "text": "tri",
                "value": "ride_tri.flac"
            },
            {
                "text": "via",
                "value": "ride_via.flac"
            }
        ]
    },
    {
        "id": "perc",
        "label": "Percussion",
        "items": [
            {
                "text": "bell",
                "value": "perc_bell.flac"
            },
            {
                "text": "bell2",
                "value": "perc_bell2.flac"
            },
            {
                "text": "door",
                "value": "perc_door.flac"
            },
            {
                "text": "impact1",
                "value": "perc_impact1.flac"
            },
            {
                "text": "impact2",
                "value": "perc_impact2.flac"
            },
            {
                "text": "snap",
                "value": "perc_snap.flac"
            },
            {
                "text": "snap2",
                "value": "perc_snap2.flac"
            },
            {
                "text": "swash",
                "value": "perc_swash.flac"
            },
            {
                "text": "swoosh",
                "value": "perc_swoosh.flac"
            },
            {
                "text": "till",
                "value": "perc_till.flac"
            },
            {
                "text": "dhec",
                "value": "tabla_dhec.flac"
            },
            {
                "text": "ghe1",
                "value": "tabla_ghe1.flac"
            },
            {
                "text": "ghe2",
                "value": "tabla_ghe2.flac"
            },
            {
                "text": "ghe3",
                "value": "tabla_ghe3.flac"
            },
            {
                "text": "ghe4",
                "value": "tabla_ghe4.flac"
            },
            {
                "text": "ghe5",
                "value": "tabla_ghe5.flac"
            },
            {
                "text": "ghe6",
                "value": "tabla_ghe6.flac"
            },
            {
                "text": "ghe7",
                "value": "tabla_ghe7.flac"
            },
            {
                "text": "ghe8",
                "value": "tabla_ghe8.flac"
            },
            {
                "text": "ke1",
                "value": "tabla_ke1.flac"
            },
            {
                "text": "ke2",
                "value": "tabla_ke2.flac"
            },
            {
                "text": "ke3",
                "value": "tabla_ke3.flac"
            },
            {
                "text": "na",
                "value": "tabla_na.flac"
            },
            {
                "text": "na o",
                "value": "tabla_na_o.flac"
            },
            {
                "text": "na s",
                "value": "tabla_na_s.flac"
            },
            {
                "text": "re",
                "value": "tabla_re.flac"
            },
            {
                "text": "tas1",
                "value": "tabla_tas1.flac"
            },
            {
                "text": "tas2",
                "value": "tabla_tas2.flac"
            },
            {
                "text": "tas3",
                "value": "tabla_tas3.flac"
            },
            {
                "text": "te1",
                "value": "tabla_te1.flac"
            },
            {
                "text": "te2",
                "value": "tabla_te2.flac"
            },
            {
                "text": "te m",
                "value": "tabla_te_m.flac"
            },
            {
                "text": "te ne",
                "value": "tabla_te_ne.flac"
            },
            {
                "text": "tun1",
                "value": "tabla_tun1.flac"
            },
            {
                "text": "tun2",
                "value": "tabla_tun2.flac"
            },
            {
                "text": "tun3",
                "value": "tabla_tun3.flac"
            }
        ]
    },
    {
        "id": "elec",
        "label": "Electronic",
        "items": [
            {
                "text": "beep",
                "value": "elec_beep.flac"
            },
            {
                "text": "bell",
                "value": "elec_bell.flac"
            },
            {
                "text": "blip",
                "value": "elec_blip.flac"
            },
            {
                "text": "blip2",
                "value": "elec_blip2.flac"
            },
            {
                "text": "blup",
                "value": "elec_blup.flac"
            },
            {
                "text": "bong",
                "value": "elec_bong.flac"
            },
            {
                "text": "chime",
                "value": "elec_chime.flac"
            },
            {
                "text": "cymbal",
                "value": "elec_cymbal.flac"
            },
            {
                "text": "filt snare",
                "value": "elec_filt_snare.flac"
            },
            {
                "text": "flip",
                "value": "elec_flip.flac"
            },
            {
                "text": "fuzz tom",
                "value": "elec_fuzz_tom.flac"
            },
            {
                "text": "hi snare",
                "value": "elec_hi_snare.flac"
            },
            {
                "text": "hollow kick",
                "value": "elec_hollow_kick.flac"
            },
            {
                "text": "lo snare",
                "value": "elec_lo_snare.flac"
            },
            {
                "text": "mid snare",
                "value": "elec_mid_snare.flac"
            },
            {
                "text": "ping",
                "value": "elec_ping.flac"
            },
            {
                "text": "plip",
                "value": "elec_plip.flac"
            },
            {
                "text": "pop",
                "value": "elec_pop.flac"
            },
            {
                "text": "snare",
                "value": "elec_snare.flac"
            },
            {
                "text": "soft kick",
                "value": "elec_soft_kick.flac"
            },
            {
                "text": "tick",
                "value": "elec_tick.flac"
            },
            {
                "text": "triangle",
                "value": "elec_triangle.flac"
            },
            {
                "text": "twang",
                "value": "elec_twang.flac"
            },
            {
                "text": "twip",
                "value": "elec_twip.flac"
            },
            {
                "text": "wood",
                "value": "elec_wood.flac"
            }
        ]
    },
    {
        "id": "bass",
        "label": "Bass",
        "items": [
            {
                "text": "dnb f",
                "value": "bass_dnb_f.flac"
            },
            {
                "text": "drop c",
                "value": "bass_drop_c.flac"
            },
            {
                "text": "hard c",
                "value": "bass_hard_c.flac"
            },
            {
                "text": "hit c",
                "value": "bass_hit_c.flac"
            },
            {
                "text": "thick c",
                "value": "bass_thick_c.flac"
            },
            {
                "text": "trance c",
                "value": "bass_trance_c.flac"
            },
            {
                "text": "voxy c",
                "value": "bass_voxy_c.flac"
            },
            {
                "text": "voxy hit c",
                "value": "bass_voxy_hit_c.flac"
            },
            {
                "text": "woodsy c",
                "value": "bass_woodsy_c.flac"
            }
        ]
    },
    {
        "id": "loops",
        "label": "Loops",
        "items": [
            {
                "text": "3d printer",
                "value": "loop_3d_printer.flac"
            },
            {
                "text": "amen",
                "value": "loop_amen.flac"
            },
            {
                "text": "amen full",
                "value": "loop_amen_full.flac"
            },
            {
                "text": "breakbeat",
                "value": "loop_breakbeat.flac"
            },
            {
                "text": "compus",
                "value": "loop_compus.flac"
            },
            {
                "text": "drone g 97",
                "value": "loop_drone_g_97.flac"
            },
            {
                "text": "electric",
                "value": "loop_electric.flac"
            },
            {
                "text": "garzul",
                "value": "loop_garzul.flac"
            },
            {
                "text": "industrial",
                "value": "loop_industrial.flac"
            },
            {
                "text": "mehackit1",
                "value": "loop_mehackit1.flac"
            },
            {
                "text": "mehackit2",
                "value": "loop_mehackit2.flac"
            },
            {
                "text": "mika",
                "value": "loop_mika.flac"
            },
            {
                "text": "perc1",
                "value": "loop_perc1.flac"
            },
            {
                "text": "perc2",
                "value": "loop_perc2.flac"
            },
            {
                "text": "safari",
                "value": "loop_safari.flac"
            },
            {
                "text": "tabla",
                "value": "loop_tabla.flac"
            },
            {
                "text": "weirdo",
                "value": "loop_weirdo.flac"
            }
        ]
    },
    {
        "id": "beats",
        "label": "Beat loops",
        "items": [
            {
                "text": "beat a",
                "value": "arovane_beat_a.flac"
            },
            {
                "text": "beat b",
                "value": "arovane_beat_b.flac"
            },
            {
                "text": "beat c",
                "value": "arovane_beat_c.flac"
            },
            {
                "text": "beat d",
                "value": "arovane_beat_d.flac"
            },
            {
                "text": "beat e",
                "value": "arovane_beat_e.flac"
            },
            {
                "text": "fxbed loop",
                "value": "tbd_fxbed_loop.flac"
            },
            {
                "text": "highkey c4",
                "value": "tbd_highkey_c4.flac"
            },
            {
                "text": "pad 1",
                "value": "tbd_pad_1.flac"
            },
            {
                "text": "pad 2",
                "value": "tbd_pad_2.flac"
            },
            {
                "text": "pad 3",
                "value": "tbd_pad_3.flac"
            },
            {
                "text": "pad 4",
                "value": "tbd_pad_4.flac"
            },
            {
                "text": "perc blip",
                "value": "tbd_perc_blip.flac"
            },
            {
                "text": "perc hat",
                "value": "tbd_perc_hat.flac"
            },
            {
                "text": "perc tap 1",
                "value": "tbd_perc_tap_1.flac"
            },
            {
                "text": "perc tap 2",
                "value": "tbd_perc_tap_2.flac"
            },
            {
                "text": "voctone",
                "value": "tbd_voctone.flac"
            }
        ]
    },
    {
        "id": "ambient",
        "label": "Ambient",
        "items": [
            {
                "text": "choir",
                "value": "ambi_choir.flac"
            },
            {
                "text": "dark woosh",
                "value": "ambi_dark_woosh.flac"
            },
            {
                "text": "drone",
                "value": "ambi_drone.flac"
            },
            {
                "text": "glass hum",
                "value": "ambi_glass_hum.flac"
            },
            {
                "text": "glass rub",
                "value": "ambi_glass_rub.flac"
            },
            {
                "text": "haunted hum",
                "value": "ambi_haunted_hum.flac"
            },
            {
                "text": "lunar land",
                "value": "ambi_lunar_land.flac"
            },
            {
                "text": "piano",
                "value": "ambi_piano.flac"
            },
            {
                "text": "sauna",
                "value": "ambi_sauna.flac"
            },
            {
                "text": "soft buzz",
                "value": "ambi_soft_buzz.flac"
            },
            {
                "text": "swoosh",
                "value": "ambi_swoosh.flac"
            }
        ]
    },
    {
        "id": "guitar",
        "label": "Guitar",
        "items": [
            {
                "text": "e fifths",
                "value": "guit_e_fifths.flac"
            },
            {
                "text": "e slide",
                "value": "guit_e_slide.flac"
            },
            {
                "text": "em9",
                "value": "guit_em9.flac"
            },
            {
                "text": "harmonics",
                "value": "guit_harmonics.flac"
            }
        ]
    },
    {
        "id": "glitch",
        "label": "Glitch",
        "items": [
            {
                "text": "bass g",
                "value": "glitch_bass_g.flac"
            },
            {
                "text": "perc1",
                "value": "glitch_perc1.flac"
            },
            {
                "text": "perc2",
                "value": "glitch_perc2.flac"
            },
            {
                "text": "perc3",
                "value": "glitch_perc3.flac"
            },
            {
                "text": "perc4",
                "value": "glitch_perc4.flac"
            },
            {
                "text": "perc5",
                "value": "glitch_perc5.flac"
            },
            {
                "text": "robot1",
                "value": "glitch_robot1.flac"
            },
            {
                "text": "robot2",
                "value": "glitch_robot2.flac"
            }
        ]
    },
    {
        "id": "vinyl",
        "label": "Vinyl",
        "items": [
            {
                "text": "backspin",
                "value": "vinyl_backspin.flac"
            },
            {
                "text": "hiss",
                "value": "vinyl_hiss.flac"
            },
            {
                "text": "rewind",
                "value": "vinyl_rewind.flac"
            },
            {
                "text": "scratch",
                "value": "vinyl_scratch.flac"
            }
        ]
    },
    {
        "id": "mehackit",
        "label": "Mehackit",
        "items": [
            {
                "text": "phone1",
                "value": "mehackit_phone1.flac"
            },
            {
                "text": "phone2",
                "value": "mehackit_phone2.flac"
            },
            {
                "text": "phone3",
                "value": "mehackit_phone3.flac"
            },
            {
                "text": "phone4",
                "value": "mehackit_phone4.flac"
            },
            {
                "text": "robot1",
                "value": "mehackit_robot1.flac"
            },
            {
                "text": "robot2",
                "value": "mehackit_robot2.flac"
            },
            {
                "text": "robot3",
                "value": "mehackit_robot3.flac"
            },
            {
                "text": "robot4",
                "value": "mehackit_robot4.flac"
            },
            {
                "text": "robot5",
                "value": "mehackit_robot5.flac"
            },
            {
                "text": "robot6",
                "value": "mehackit_robot6.flac"
            },
            {
                "text": "robot7",
                "value": "mehackit_robot7.flac"
            }
        ]
    },
    {
        "id": "misc",
        "label": "Misc",
        "items": [
            {
                "text": "misc burp",
                "value": "misc_burp.flac"
            },
            {
                "text": "misc cineboom",
                "value": "misc_cineboom.flac"
            },
            {
                "text": "misc crow",
                "value": "misc_crow.flac"
            }
        ]
    }
];

const SAMPLE_BLOCK_DEFS = [
    {
        "categoryId": "drums",
        "categoryLabel": "Drums",
        "opcode": "playDrumSample",
        "menu": "DRUM_SAMPLES",
        "arg": "DRUM",
        "blockLabel": "drum",
        "defaultSample": "drum_bass_hard.flac"
    },
    {
        "categoryId": "hats",
        "categoryLabel": "Hats & bass drum",
        "opcode": "playHatSample",
        "menu": "HAT_SAMPLES",
        "arg": "HAT",
        "blockLabel": "hat",
        "defaultSample": "bd_808.flac"
    },
    {
        "categoryId": "snares",
        "categoryLabel": "Snares",
        "opcode": "playSnareSample",
        "menu": "SNARE_SAMPLES",
        "arg": "SNARE",
        "blockLabel": "snare",
        "defaultSample": "sn_dolf.flac"
    },
    {
        "categoryId": "cymbals",
        "categoryLabel": "Ride cymbals",
        "opcode": "playCymbalSample",
        "menu": "CYMBAL_SAMPLES",
        "arg": "CYMBAL",
        "blockLabel": "ride cymbal",
        "defaultSample": "ride_tri.flac"
    },
    {
        "categoryId": "perc",
        "categoryLabel": "Percussion",
        "opcode": "playPercussionSample",
        "menu": "PERC_SAMPLES",
        "arg": "PERC",
        "blockLabel": "percussion",
        "defaultSample": "perc_bell.flac"
    },
    {
        "categoryId": "elec",
        "categoryLabel": "Electronic",
        "opcode": "playElectronicSample",
        "menu": "ELEC_SAMPLES",
        "arg": "ELEC",
        "blockLabel": "electronic",
        "defaultSample": "elec_beep.flac"
    },
    {
        "categoryId": "bass",
        "categoryLabel": "Bass",
        "opcode": "playBassSample",
        "menu": "BASS_SAMPLES",
        "arg": "BASS",
        "blockLabel": "bass",
        "defaultSample": "bass_dnb_f.flac"
    },
    {
        "categoryId": "loops",
        "categoryLabel": "Loops",
        "opcode": "playLoopSample",
        "menu": "LOOP_SAMPLES",
        "arg": "LOOP",
        "blockLabel": "loop",
        "defaultSample": "loop_3d_printer.flac"
    },
    {
        "categoryId": "beats",
        "categoryLabel": "Beat loops",
        "opcode": "playBeatLoopSample",
        "menu": "BEAT_LOOP_SAMPLES",
        "arg": "BEAT",
        "blockLabel": "beat loop",
        "defaultSample": "arovane_beat_a.flac"
    },
    {
        "categoryId": "ambient",
        "categoryLabel": "Ambient",
        "opcode": "playAmbientSample",
        "menu": "AMBIENT_SAMPLES",
        "arg": "AMBIENT",
        "blockLabel": "ambient",
        "defaultSample": "ambi_choir.flac"
    },
    {
        "categoryId": "guitar",
        "categoryLabel": "Guitar",
        "opcode": "playGuitarSample",
        "menu": "GUITAR_SAMPLES",
        "arg": "GUITAR",
        "blockLabel": "guitar",
        "defaultSample": "guit_e_fifths.flac"
    },
    {
        "categoryId": "glitch",
        "categoryLabel": "Glitch",
        "opcode": "playGlitchSample",
        "menu": "GLITCH_SAMPLES",
        "arg": "GLITCH",
        "blockLabel": "glitch",
        "defaultSample": "glitch_bass_g.flac"
    },
    {
        "categoryId": "vinyl",
        "categoryLabel": "Vinyl",
        "opcode": "playVinylSample",
        "menu": "VINYL_SAMPLES",
        "arg": "VINYL",
        "blockLabel": "vinyl",
        "defaultSample": "vinyl_backspin.flac"
    },
    {
        "categoryId": "mehackit",
        "categoryLabel": "Mehackit",
        "opcode": "playMehackitSample",
        "menu": "MEHACKIT_SAMPLES",
        "arg": "MEHACKIT",
        "blockLabel": "mehackit",
        "defaultSample": "mehackit_phone1.flac"
    },
    {
        "categoryId": "misc",
        "categoryLabel": "Misc",
        "opcode": "playMiscSample",
        "menu": "MISC_SAMPLES",
        "arg": "MISC",
        "blockLabel": "misc",
        "defaultSample": "misc_burp.flac"
    }
];

const SAMPLE_BY_VALUE = {};
for (const category of SAMPLE_CATEGORIES) {
    for (const item of category.items) {
        SAMPLE_BY_VALUE[item.value] = {
            categoryId: category.id,
            categoryLabel: category.label,
            text: item.text
        };
    }
}

module.exports = {
    SAMPLE_CATEGORIES,
    SAMPLE_BLOCK_DEFS,
    SAMPLE_BY_VALUE
};
